import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, View, UpdateViewRequest } from "@/types";

export function useUpdateView() {
  const mutation = useMutation({
    mutationFn: async ({
      id,
      updateViewRequest,
    }: {
      id: number;
      updateViewRequest: UpdateViewRequest;
    }) => {
      const path = `views/${id.toString()}`;
      const res = await guacHttpClient.patch<
        View,
        HttpResponse<View>,
        UpdateViewRequest
      >(path, updateViewRequest);

      return res.data;
    },
  });

  return mutation;
}
